// @flow

import singleSelectStrategy from '../single-select-strategy';
import multiSelectStrategy from '../multi-select-strategy';

const strategies = {
  'single-select': singleSelectStrategy,
  'multi-select': multiSelectStrategy,
};

const simpleStrategy = (facet: FacetWithConfig): boolean => {
  const optionHasAnInvalidName = option => !option.name;

  if (facet.options.every(optionHasAnInvalidName)) {
    return false;
  }

  const strategy = strategies[facet.selectionType];
  return strategy ? strategy(facet) : true;
};

export default simpleStrategy;